import React from 'react';
import './App.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/700.css';

function App() {
  return (
    <div className="gradient-container">
      <div className="content">
        <h1 className="title">Coming soon - Desire Bot</h1>
        <p className="caption">A feature-rich Discord bot that simplifies moderation, utilities, and fun.</p>
      </div>
    </div>
  );
}

export default App;